import {DataGridSearchParams} from '../../constants/urlSync';
import {SOURCE_DATA_GRID} from './getSourceSearchParams';
import {sourceDataGridParser} from './parsers';

export const getFormattedSourceSearchParams = (): DataGridSearchParams => {
  const rawValue = new URL(window.location.href).searchParams.get(SOURCE_DATA_GRID) ?? '';
  return (
    sourceDataGridParser.parse(rawValue) ?? {
      gridCode: undefined as unknown as string,
      queryId: undefined as unknown as string,
      rowIndex: undefined as unknown as string,
    }
  );
};
